if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        const values = [];
        this.querySelectorAll("select, fieldset").forEach((el) => {
          const selected =
            el.tagName === "SELECT"
              ? el.options[el.selectedIndex]
              : el.querySelector("input:checked");
          if (selected?.dataset?.optionValueId) {
            values.push(selected.dataset.optionValueId);
          }
        });
        return values;
      }

      getInputForEventTarget(target) {
        if (target.tagName === "SELECT") {
          return target.options[target.selectedIndex] || target;
        }
        return target;
      }

      connectedCallback() {
        const notifyVariantChange = (event, targetOption) => {
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target: targetOption,
                selectedOptionValues: this.selectedOptionValues,
              },
            },
          );
        };

        const runAfterNextPaint = (fn) => {
          if (this._pendingRaf) cancelAnimationFrame(this._pendingRaf);
          requestAnimationFrame(() => {
            this._pendingRaf = requestAnimationFrame(() => {
              this._pendingRaf = null;
              fn();
            });
          });
        };

        const NOTIFY_DEBOUNCE_MS = 400;

        this.addEventListener("change", (event) => {
          const target = event.target;
          if (!target.matches('select, input[type="radio"]')) return;

          this.updateSelectedSwatchValue(event);
          const targetOption = this.getInputForEventTarget(target);

          if (target.type === "radio") {
            runAfterNextPaint(() => {
              const now = Date.now();
              if (
                this._lastNotifyInput === targetOption &&
                now - (this._lastNotifyTime || 0) < NOTIFY_DEBOUNCE_MS
              )
                return;
              this._lastNotifyInput = targetOption;
              this._lastNotifyTime = now;
              notifyVariantChange(event, targetOption);
            });
          } else {
            notifyVariantChange(event, targetOption);
          }
        });

        const resolveRadioInput = (eventTarget) => {
          if (!eventTarget || !this.contains(eventTarget)) return null;
          if (
            eventTarget.type === "radio" &&
            eventTarget.matches("input[name]")
          )
            return eventTarget;
          const label =
            eventTarget.tagName === "LABEL"
              ? eventTarget
              : eventTarget.closest?.("label");
          if (!label?.htmlFor) return null;
          const input = document.getElementById(label.htmlFor);
          return input?.type === "radio" && this.contains(input) ? input : null;
        };

        const notifyIfRadioTapped = (event, eventTarget) => {
          const input = resolveRadioInput(eventTarget);
          if (!input) return;
          runAfterNextPaint(() => {
            if (!input.checked) return;
            const now = Date.now();
            if (
              this._lastNotifyInput === input &&
              now - (this._lastNotifyTime || 0) < NOTIFY_DEBOUNCE_MS
            )
              return;
            this._lastNotifyInput = input;
            this._lastNotifyTime = now;
            this.updateSelectedSwatchValue({ target: input });
            notifyVariantChange(event, input);
          });
        };

        this.addEventListener("click", (event) => {
          const input = resolveRadioInput(event.target);
          if (!input) return;
          notifyIfRadioTapped(event, event.target);
        });

        this.addEventListener(
          "touchend",
          (event) => {
            const input = resolveRadioInput(event.target);
            if (!input) return;
            notifyIfRadioTapped(event, event.target);
          },
          { passive: true },
        );
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue,
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset",
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    },
  );
}
